var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { applyWPSProxyUrl } from "../common.js";
import { setAuthHeader } from "../utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const TAGS = {
  FEATUREV2: "FeatureV2"
};
const vnextFeatureReadV2ApiBaseQuery = (args, api, extraOptions) => __async(void 0, null, function* () {
  const apiVersion = "2.0";
  const baseUrl = applyWPSProxyUrl(`${EnvironmentService.endpoints.expmanAdapter.url}api/${apiVersion}`);
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => __async(void 0, null, function* () {
      yield setAuthHeader({ tokenScope: EnvironmentService.endpoints.default.tokenScope }, headers);
      headers.set("Cache-Control", "no-cache");
      return headers;
    })
  });
  return rawBaseQuery(args, api, extraOptions);
});
export {
  TAGS,
  vnextFeatureReadV2ApiBaseQuery
};
//# sourceMappingURL=common.js.map
